<div class="content-wrapper">
  @if (particularities()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          Alle bijzonderheden
          <span>({{ totalParticularities() }})</span>
        </h2>
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label>Zoeken</mat-label>
          <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
          <button
            mat-icon-button
            matSuffix
            aria-label="Zoekopdracht wissen"
            (click)="clearSearch(); $event.stopPropagation()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <mat-table mat-table #table [dataSource]="filteredParticularities()">
        <!-- Icon Column -->
        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef>Symbool</mat-header-cell>
          <mat-cell *matCellDef="let particularity">
            <mat-icon [svgIcon]="particularity.id"></mat-icon>
          </mat-cell>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Naam</mat-header-cell>
          <mat-cell *matCellDef="let particularity">
            @if (particularity.name) {
              <p class="text-truncate">
                {{ particularity.name }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <mat-header-cell class="hide-column" *matHeaderCellDef>Beschrijving</mat-header-cell>
          <mat-cell class="hide-column" *matCellDef="let particularity">
            @if (particularity.description) {
              <p class="text-truncate">
                {{ particularity.description }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- button Column -->
        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let particularity">
            <div class="buttons">
              <button mat-icon-button aria-label="Bijzonderheid bewerken">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                aria-label="Bijzonderheid verwijderen"
                [disabled]="isSystemParticularity(particularity)"
                (click)="deleteItem(particularity); $event.stopPropagation()"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let particularity; columns: displayedColumns"
          class="user"
          role="button"
          tabindex="0"
          aria-label="Bijzonderheid openen"
          (click)="editItem(particularity)"
          (keydown.enter)="editItem(particularity)"
          (keydown.space)="$event.preventDefault(); editItem(particularity)"
          matRipple
        ></tr>
      </mat-table>
    </mat-card>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
